import { setTasksVisualizationFilter as setTasksVisualizationFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    filter?: Number,
}

export const setTasksVisualizationFilter = ({
    filter,
    eventEmitter,
}: Props) => {
    setTasksVisualizationFilterDiagram(filter);
};
